import Layers from "slotworks/graphics/layers/layers";
import { sequence } from "slotworks/utils/race-utils";
import gameState from "slotworks/model/game-state";

export function HideGameElementsCommand() {
    Layers.MatrixBackground.hide();
    Layers.MatrixContent.hide();
    Layers.MatrixForeground.hide();
    Layers.Custom.get("Grass").hide();
    Layers.Banners.hide();
    Layers.Custom.get("JackpotMeters").hide();
    Layers.Custom.get("BonusBuy").hide();
    Layers.Custom.get("Feature").hide();
    Layers.Custom.get("Anticipation").hide();
}

export function ShowGameElementsCommand() {
    if(gameState.getCurrentGame().inFreespinsGame) {
        Layers.Background.setScene("freespins").execute();
    } else {
        Layers.Background.defaultScene().execute();
        Layers.Custom.get("BonusBuy").show();
        Layers.Custom.get("Feature").show();
    }
    Layers.MatrixBackground.show();
    Layers.MatrixContent.show();
    Layers.MatrixForeground.show();
    Layers.Custom.get("Grass").show();
    Layers.Banners.show();
    Layers.Custom.get("JackpotMeters").show();
    Layers.Custom.get("Anticipation").show();
    sequence([
        () => Layers.Custom.get("RespinMeters").defaultScene(),
        () => Layers.Custom.get("RespinBackground").defaultScene(),
        () => Layers.Custom.get("Respin").defaultScene(),
        () => Layers.Custom.get("Leprechaun").defaultScene(),
        () => Layers.Custom.get("RespinForeground").defaultScene(),
        () => Layers.Custom.get("RespinTexts").defaultScene(),
        () => Layers.Custom.get("River").defaultScene()
    ]).execute();
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/commands/respin-commands.ts